import './Order.scss'
import {FaCheck,FaSearch} from 'react-icons/fa'
import DatePicker,{getAllDatesInRange} from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/prime.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePanel from "react-multi-date-picker/plugins/date_panel"

import React,{useState} from 'react';

export default function Orders() {

    const [value, setValue] = useState("");
     

    return<>
        <div className="border  w-100 mx-3 Orders bg-white">

            <div class="card shadow mx-auto my-3" style={{width:"95%",borderRadius:'10px'}}>
                <div class="card-header bg-white py-4 mb-3 border-bottom-3 border-dark mx-3" >
                <FaSearch className='mx-2' />
                جستجوی فاکتو
                </div>
                <div class="card-body d-flex flex-row p-0 pb-5" >
                    <div className=' mx-3' >
                        <label className='form-label' for='factor'>شماره فاکتور</label>
                        <input className='form-control' id='factor' />
                    </div>
                    <div className=' mx-3 d-flex flex-column' >
                        <label className='form-label' for="date">محدوده تاریخی</label>
                        <DatePicker id='date' mainPosition="bottom" fixMainPosition={true}   style={{height:"38px",width:"100%"}} value={value} onChange={setValue} calendar={persian} locale={persian_fa}  range plugins={[ <DatePanel /> ]} />
                    </div>
                    
                    
                </div>
            </div>

            <div class="card m-3 mx-auto shadow" style={{borderRadius:"10px",width:"95%"}}>
               
               <div class="card-body d-flex flex-row flex-wrap p-0 text-center border-bottom ">
                  
                   <div className='flex-fill'>
                       <div className=" px-3  py-3 rediusR-class"  style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                               شماره فاکتور 
                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                               111134 
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className=" px-3  py-3 rediusL-class22"  style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           نوع سفارش 

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                               بلیط هواپیما 
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill' >
                       <div className=" px-3  py-3 rediusL-class32" style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           نام شرکت هواپیمایی

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                               ایران ایر

                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className=" px-3  py-3 rediusL-class42" style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           مبدا  

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                           گرگان
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className=" px-3  py-3 rediusL-class52" style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           مقصد  

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                           تهران
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className=" px-3  py-3 rediusL-class62" style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           تاریخ و ساعت  

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                           1399/2/2 18:22
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className=" px-3  py-3 rediusL-class72" style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           نام فرودگاه

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                           امام
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className=" px-3  py-3 rediusL-class82" style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           مبلغ ( <small>تومان</small> )

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span className='text-success'>
                               350000
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className="px-3  py-3 rediusL-class92"  style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           تخفیف

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span className='text-danger'>
                               0
                           </span>
                       </div>
                   </div>
                  
               </div>
               <div className='text-center'>
                   <div className="py-2 fs-5">
                       وضعیت 
                   </div>
                   <div>
                       <div class="container d-flex justify-content-center align-items-center my-5">
                           <div class="progresses">
                               <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>خرید</span> <span class="font-weight-bold text-white">5</span> </div> <span class="line"></span>
                               <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>در حال خرید</span> <span class="font-weight-bold text-white">4</span> </div> <span class="line"></span>
                               <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>بایگانی</span> <span class="font-weight-bold text-white">3</span> </div> <span class="line"></span>
                               <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>لغو</span> <span class="font-weight-bold text-white"><FaCheck/></span> </div> <span class="line"></span>
                               <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>رزرو</span> <span class="font-weight-bold text-white"><FaCheck/></span> </div>
                           </div>
                       </div>
                   </div>
               </div>
            </div>

            <div class="card m-3 mx-auto shadow" style={{borderRadius:"10px",width:"95%"}}>
               
                <div class="card-body d-flex flex-row flex-wrap p-0 text-center border-bottom" >
                   
                    <div className='flex-fill'>
                        <div className="px-3  py-3 rediusR-class"  style={{backgroundColor:"#D6EEEB"}}>
                            <span>
                                شماره فاکتور 
                            </span>
                        </div>
                        <div className="px-3 py-3">
                            <span>
                                111134 
                            </span>
                        </div>
                    </div>
                    <div className='flex-fill'>
                        <div className="px-3  py-3 rediusL-class2"  style={{backgroundColor:"#D6EEEB"}}>
                            <span>
                            نوع سفارش 

                            </span>
                        </div>
                        <div className="px-3 py-3">
                            <span>
                                تور 
                            </span>
                        </div>
                    </div>
                    <div className='flex-fill' >
                        <div className="px-3  py-3 rediusL-class3" style={{backgroundColor:"#D6EEEB"}}>
                            <span>
                            نام تور

                            </span>
                        </div>
                        <div className="px-3 py-3">
                            <span>
                                تور آنتالیا 

                            </span>
                        </div>
                    </div>
                    <div className='flex-fill'>
                        <div className="px-3  py-3 rediusL-class4" style={{backgroundColor:"#D6EEEB"}}>
                            <span>
                                تاریخ 

                            </span>
                        </div>
                        <div className="px-3 py-3">
                            <span>
                                1399/2/2
                            </span>
                        </div>
                    </div>
                    <div className='flex-fill'>
                        <div className="px-3  py-3 rediusL-class5 " style={{backgroundColor:"#D6EEEB"}}>
                            <span>
                            مبلغ ( <small>تومان</small> )

                            </span>
                        </div>
                        <div className="px-3 py-3">
                            <span className='text-success'>
                                350000
                            </span>
                        </div>
                    </div>
                    <div className='flex-fill'>
                        <div className="px-3  py-3 rediusL-class6 "  style={{backgroundColor:"#D6EEEB"}}>
                            <span>
                            تخفیف

                            </span>
                        </div>
                        <div className="px-3 py-3">
                            <span className='text-danger'>
                                0
                            </span>
                        </div>
                    </div>
                    <div className='flex-fill'>
                        <div className="px-3  py-3 rediusL-class"  style={{backgroundColor:"#D6EEEB"}}>
                            <span>
                            عملیات

                            </span>
                        </div>
                        <div className="px-3 py-2 d-flex flex-row mx-auto" style={{width:"fit-content"}}>
                            <button className="btn text-white font-class" style={{backgroundColor:"#457B9D"}}>افزودن همراه</button>
                            <button className="btn mx-1 text-white font-class" style={{backgroundColor:"#668CD9"}} >تکمیل وجه</button>
                            <button className="btn btn-danger text-white font-class">کنسل کردن تور</button>
                        </div>
                    </div>
                </div>
                <div className='text-center'>
                    <div className="py-2 fs-5">
                        وضعیت 
                    </div>
                    <div>
                        <div class="container d-flex justify-content-center align-items-center my-5">
                            <div class="progresses">
                                <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>اجرا شده</span> <span class="font-weight-bold text-white">5</span> </div> <span class="line"></span>
                                <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>درحال اجرا</span> <span class="font-weight-bold text-white">4</span> </div> <span class="line"></span>
                                <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>در انتظار اجرا</span> <span class="font-weight-bold text-white">3</span> </div> <span class="line"></span>
                                <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>ثبت نام</span> <span class="font-weight-bold text-white"><FaCheck/></span> </div> <span class="line"></span>
                                <div class="steps position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>پیش ثبت نام</span> <span class="font-weight-bold text-white"><FaCheck/></span> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           <div class="card m-3 mx-auto shadow" style={{borderRadius:"10px",width:"95%"}}>
               <div class="card-body d-flex flex-row flex-wrap p-0 text-center border-bottom ">
                  
                   <div className='flex-fill'>
                       <div className="px-3  py-3 rediusR-class"  style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                               شماره فاکتور 
                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                               111134 
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className="px-3  py-3 rediusL-class21"  style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           نام کال 

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                           چای سبز
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill' >
                       <div className="px-3  py-3 rediusL-class31" style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           تعداد

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                               سه عدد 

                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className="px-3  py-3 rediusL-class41" style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           تاریخ و ساعت سفارش 

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                           399/2/2 18:22
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className="px-3  py-3 rediusL-class51"  style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           تاریخ تحویل

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span>
                           1399/3/2
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className="px-3  py-3 rediusL-class61" style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           مبلغ ( <small>تومان</small> )

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span className='text-success'>
                               350000
                           </span>
                       </div>
                   </div>
                   <div className='flex-fill'>
                       <div className="px-3  py-3 rediusL-class11 rediusL-class1 " style={{backgroundColor:"#D6EEEB"}}>
                           <span>
                           تخفیف

                           </span>
                       </div>
                       <div className="px-3 py-3">
                           <span className='text-danger'>
                               350000
                           </span>
                       </div>
                   </div>
               </div>

               <div className='text-center'>
                   <div className="py-2 fs-5">
                       وضعیت 
                   </div>
                   <div>
                       <div class="container d-flex justify-content-center align-items-center my-5">
                           <div class="progresses">
                               <div class="steps2 position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>ارسال شده</span> <span class="font-weight-bold text-white">4</span> </div> <span class="line"></span>
                               <div class="steps2 position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>لغو شده</span> <span class="font-weight-bold text-white">3</span> </div> <span class="line"></span>
                               <div class="steps2 position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>درحال ارسال</span> <span class="font-weight-bold text-white"><FaCheck/></span> </div> <span class="line"></span>
                               <div class="steps2 position-relative"> <span className='position-absolute font-class' style={{top:"-25px",width:"100px"}}>در حال پردازش</span> <span class="font-weight-bold text-white"><FaCheck/></span> </div>
                           </div>
                       </div>
                   </div>
               </div>
           </div>

            <div className='mx-auto text-center p-3 my-4 rounded-3' style={{width:"fit-content",backgroundColor:"#D6EEEB"}}>
                مبلغ کل سفارشات
                <span className='mx-3'>
                    1234
                </span>
            </div>

        </div>
    </>
}